import "./customAdsTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const CustomAdsTable = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  useEffect(() => {
    fetchAds();
  }, []);

  const fetchAds = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/api/adsCustom/findAllCustomAds/1`,
      );
      setData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(
        `${BASE_URL}/api/adsCustom/deleteCustomAds/${selectedUserId}`,
      );

      setData((prev) => prev.filter((item) => item._id !== selectedUserId));

      setOpenDialog(false);
    } catch (err) {
      console.error(err);
    }
  };

  const columns = [
    {
      field: "village",
      headerName: "Village / Club",
      width: 300,
      renderCell: (params) => {
        const firstImage = params.row.customAdsImages?.[0]?.url;

        console.log("First Image URL:", firstImage);

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <img
              src={firstImage}
              alt=""
              style={{
                width: 55,
                height: 55,
                objectFit: "cover",
                borderRadius: 8,
              }}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/55?text=No+Image";
              }}
            />

            <div>
              <strong>
                {params.row.userId?.villageName || params.row.userId?.clubName}
              </strong>
            </div>
          </div>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <IconButton
          color="error"
          onClick={() => {
            setSelectedUserId(params.row._id);
            setOpenDialog(true);
          }}
        >
          <Delete />
        </IconButton>
      ),
    },
  ];

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5">Custom Ads List</Typography>
        <Button
          variant="contained"
          onClick={() => navigate("/customads/newCustomAds")}
        >
          Add Custom Ads
        </Button>
      </div>

      {loading ? (
        <CircularProgress />
      ) : (
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row._id}
          autoHeight
          pageSizeOptions={[5]}
        />
      )}

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this Custom Ads?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button color="error" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CustomAdsTable;
